module.exports = __webpack_public_path__ + "static/media/thaitvonline3.f975d615.png";